import { Avatar, AvatarFallback } from '@/components/ui/avatar'

/**
 * The signed-in user, where the app renders its account menu. Drawn rather
 * than real: these are prototypes, and the live control shows a Sign in button
 * to anyone reviewing them without a session.
 */
export function SignedInAvatar() {
  return (
    <Avatar className="size-7">
      <AvatarFallback className="bg-ink-100 text-ink text-[10px] font-medium">JM</AvatarFallback>
    </Avatar>
  )
}
